import { Injectable } from '@angular/core';
import { DataSaleInt, PaymentInfoInt } from '@interfaces/*';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { catchError, map } from 'rxjs/operators';
import { PassengerMapper } from '@mappers/passenger.mapper';
import { GlobalsService } from '@services/globals.service';
import { OPERATION_PAY } from '@app/enums/cart.enum';
import { LoadingService } from './loading.service';
import { throwError } from 'rxjs';
import { TypeLoading } from '@app/enums';
import { v4 as uuidv4 } from 'uuid';
import { ErrorAdapter } from '@models/adapter/error.adapter';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  urlPcc = environment.urlApiCheckin;
  private paymentInfo: PaymentInfoInt;
  constructor(
    private http: HttpClient,
    private _globalService: GlobalsService,
    private _loadingService: LoadingService
  ) {}

  pay(
    cartId: string,
    payData: PaymentInfoInt,
    currencyCode: string,
    operation = OPERATION_PAY.CHECKIN,
    codeBagge = '',
    amount: string
  ) {
    const body = {
      _meta: {
        class: 'PurchaseOrder',
      },
      cartId,
      operation,
      codeBagge,
      paymentInfo: { _collection: [] },
      authorizationResult: {},
    };
    if (payData) {
      body.paymentInfo._collection.push({
        _meta: {
          class: 'CreditCardPaymentRequest',
        },
        paymentAmount: {
          _meta: {
            class: 'CurrencyValue',
          },
          currencyCode,
          total: amount,
        },
        cardHolderName: payData.cartInfo.cardHolderName,
        cardType: payData.cartInfo.cardType,
        cardCode: payData.cartInfo.cardCode,
        ccNumber: payData.cartInfo.ccNumber,
        expiryDate: payData.cartInfo.expiryDate,
        securityCode: '',
      });
      body.authorizationResult = payData.autInfo;
    }
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);
    return this.http.post(`${environment.urlApi}/po`, body).pipe(
      map((res) => {
        this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
        return new PassengerMapper().checkIn(res, this._globalService.getPNRLookup());
      }),
      catchError(this.handlerError.bind(this))
    );
  }

  getPaymentInfo(): PaymentInfoInt {
    return this.paymentInfo;
  }

  setPaymentInfo(value: DataSaleInt) {
    this.paymentInfo = this.transformData(value);
  }

  private getCardType(brand) {
    switch (brand?.toLowerCase()) {
      case 'mastercard':
        return 'MSTR';
      case 'americanexpress':
        return 'AMEX';
      case 'visa':
        return 'VISA';
      default:
        return 'OTRO';
    }
  }

  private getCardCODE(brand) {
    switch (brand?.toLowerCase()) {
      case 'mastercard':
        return 'CA';
      case 'americanexpress':
      case 'amex':
        return 'AX';
      case 'visa':
        return 'VI';
      case 'carnet':
        return 'CQ';
      default:
        return 'VI';
    }
  }

  private transformData(SALE: DataSaleInt): PaymentInfoInt {
    return {
      autInfo: {
        paymentId: null,
        responseCode: 'APPROVED',
        description: 'APPROVED',
        approvalCode: SALE?.TAUT,
        approvedAmount: Number(SALE?.TAMNT),
        supplierId: 'SNTR',
        merchantAccountNumber: SALE?.IDMER,
        operationCode: SALE?.TAUT,
        transactionId: SALE?.TREF,
        operationDate: SALE?.dateOperation,
        cardReaderResult: null,
        caid: SALE?.CAID,
        carqc: SALE?.CARQC,
        cbrand: SALE?.CBRAND,
        cinstr: SALE?.CINSTR,
      },
      cartInfo: {
        cardType: this.getCardType(SALE?.CBRAND),
        cardCode: this.getCardCODE(SALE?.CBRAND),
        cardHolderName: '',
        ccNumber: SALE?.CARD,
        expiryDate: '',
      },
    };
  }

  getPCC() {
    const headers = new HttpHeaders({
      channel: environment.channel,
      flow: 'SSBD',
      storeFront: 'mx',
      project: 'SSBD',
      'x-transaction-id': uuidv4(),
    });

    return this.http
      .get(this.urlPcc + '/tc/pcc/getPccInfo', {
        headers,
      })
      .pipe(catchError(this.handlerError.bind(this)));
  }

  handlerError(error: HttpErrorResponse) {
    this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
    const errorAdapt = ErrorAdapter.adapt(error?.error);
    return throwError(errorAdapt);
  }
}
